import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiConnectOzonLogisticsMethod,
    type OpenApiConnectOzonLogisticsRequest,
    type OpenApiConnectOzonLogisticsResponseSuccess,
    OpenApiConnectOzonLogisticsUrl,
    type OpenApiDeleteOzonSetupRequest,
    type OpenApiDeleteOzonSetupResponseSuccess,
    type OpenApiGetOzonOauthSetupCredentialsRequest,
    type OpenApiGetOzonOauthSetupCredentialsResponseSuccess,
    type OpenApiGetOzonSetupRequest,
    type OpenApiGetOzonSetupResponseSuccess,
    type OpenApiSetupOzonOAuthRequest,
    type OpenApiSetupOzonOAuthResponseSuccess,
    type OpenApiSetupOzonRequest,
    type OpenApiSetupOzonResponseSuccess,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/ozonApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            setupGet: builder.query<OpenApiGetOzonSetupResponseSuccess, OpenApiGetOzonSetupRequest>({
                query: () => {
                    return {
                        url: '/integrations/ozon/setup',
                        method: 'GET',
                    };
                },
            }),
            setupAdd: builder.mutation<OpenApiSetupOzonResponseSuccess, OpenApiSetupOzonRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/ozon/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            setupDelete: builder.mutation<OpenApiDeleteOzonSetupResponseSuccess, OpenApiDeleteOzonSetupRequest>({
                query: () => {
                    return {
                        url: '/integrations/ozon/setup',
                        method: 'DELETE',
                    };
                },
            }),
            getOzonCredentials: builder.query<
                OpenApiGetOzonOauthSetupCredentialsResponseSuccess,
                OpenApiGetOzonOauthSetupCredentialsRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/ozon/credentials',
                        method: 'GET',
                    };
                },
                keepUnusedDataFor: 0,
            }),
            postOzonOauth: builder.mutation<OpenApiSetupOzonOAuthResponseSuccess, OpenApiSetupOzonOAuthRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/ozon/oauth',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            connectOzonLogistic: builder.mutation<
                OpenApiConnectOzonLogisticsResponseSuccess,
                OpenApiConnectOzonLogisticsRequest
            >({
                query: (payload) => {
                    return {
                        url: OpenApiConnectOzonLogisticsUrl,
                        method: OpenApiConnectOzonLogisticsMethod,
                        body: payload,
                    };
                },
            }),
        };
    },
});

export const useIntegrationOzonSetup = api.useSetupGetQuery;
export const useIntegrationOzonSetupLazy = api.endpoints.setupGet.useLazyQuery;
export const integrationOzonSetupGet = api.endpoints.setupGet.query;
export const lazyIntegrationOzonSetupGet = api.endpoints.setupGet.useQuery;
export const integrationOzonSetupAdd = api.endpoints.setupAdd.mutate;
export const integrationOzonSetupDelete = api.endpoints.setupDelete.mutate;
export const integrationOzonCredentialsGet = api.endpoints.getOzonCredentials.query;
export const integrationOzonOauth = api.endpoints.postOzonOauth.mutate;

export const integrationConnectOzonLogistic = api.endpoints.connectOzonLogistic.mutate;
